import { cn } from '@/clientOnlyUtils/cn';
import React from 'react';

export type Props = React.HTMLAttributes<HTMLDivElement> & {
  innerClassName?: string;
};

/**
 * Scrollable always takes as much width and height as possible and doesn't respect margins you give it.
 */
export const Scrollable = ({ className, innerClassName, children, id }: Props) => {
  return (
    <div className={cn('relative size-full grow basis-0 overflow-auto', className)} id={id}>
      <div className={cn('overflow-hidden', innerClassName)}>{children}</div>
    </div>
  );
};
